import * as React from 'react';
import { Heading1 } from '@cian/ui-kit';

import * as styles from './RedesignedRecommendationsListDesktop.css';

type TRedesignedRecommendationsListDesktopProps = {
  children: React.ReactNode;
  footer?: React.ReactNode;
  total: number;
};

export const RedesignedRecommendationsListDesktop: React.FC<TRedesignedRecommendationsListDesktopProps> = ({
  children,
  footer,
  total,
}) => (
  <section className={styles['section']}>
    <div className={styles['heading']} data-name="RedesignedRecommendationsListDesktop">
      <h1 className={styles['heading-title']}>
        <Heading1>
          Рекомендации
          <span className={styles['heading-muted']}>·</span>
          <span className={styles['heading-muted']}>{total}</span>
        </Heading1>
      </h1>
    </div>
    <div className={styles['offers-list']}>
      {children}
      {footer}
    </div>
  </section>
);
